import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "steps" }
const _hoisted_2 = { class: "step-title" }
const _hoisted_3 = { class: "badge" }
const _hoisted_4 = { class: "time" }
const _hoisted_5 = { class: "step-content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_PulseCategory = _resolveComponent("PulseCategory")
  const _component_Stepper = _resolveComponent("Stepper")
  const _component_PulseButton = _resolveComponent("PulseButton")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Stepper, {
      steps: $props.steps,
      class: "stepper",
      collapsed: $props.total > 5
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_Icon, {
          icon: "ellipse",
          stroke: "var(--brand-100)",
          "stroke-width": "1",
          width: "0.9rem",
          height: "0.9rem"
        })
      ]),
      head: _withCtx(({step}) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_PulseCategory, {
              type: step.category,
              label: step.category_label
            }, null, 8 /* PROPS */, ["type", "label"])
          ]),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$utils.format.daysAgoUTC(step.changed_at)), 1 /* TEXT */)
        ])
      ]),
      content: _withCtx(({step}) => [
        _createElementVNode("div", _hoisted_5, _toDisplayString(step.text), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["steps", "collapsed"]),
    _createVNode(_component_PulseButton, {
      text: $options.button_text,
      class: "filter",
      gap: "0.9rem",
      icon: "activity",
      count: $props.total,
      onClick: _cache[0] || (_cache[0] = $event => (_ctx.$dispatch('set-entity', $props.entityId)))
    }, null, 8 /* PROPS */, ["text", "count"])
  ]))
}